<!-- <app-lifestyle></app-lifestyle> -->

<div class="col-md-12 row clear-all flow-content">
  <app-header></app-header>
  <div class="container m-auto">
    <div class="col-md-12 clear-all">
      <div class="col-md-2 marginTop">
        <div class="row dummy"></div>
          <!-- <div class="col-md-2 marginLeft marginTop"> -->
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="col-md-10 clear-all margin-left wd-10">
          <!-- <div class="col-md-10 padding-left-0 content-wrapper"> -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>